










import { Component, Vue, Prop } from 'vue-property-decorator'
@Component

export default class AlbumItem extends Vue {
  @Prop() album: any
  @Prop() index: number
}
